const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLungs(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "800px",
    width: "800px",
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 512 512",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF5E5B"
    },
    d: "M168.489,451.654H36.285C16.277,451.654,0,435.376,0,415.368v-80.416 c0-103.012,83.804-186.816,186.816-186.816c9.918,0,17.958,8.041,17.958,17.958v249.274 C204.774,435.376,188.497,451.654,168.489,451.654z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF423D"
    },
    d: "M475.715,451.654H343.511c-20.008,0-36.285-16.277-36.285-36.285V166.094 c0-9.918,8.041-17.958,17.958-17.958C428.195,148.136,512,231.942,512,334.952v80.416C512,435.376,495.723,451.654,475.715,451.654z "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFC72D"
    },
    d: "M424.039,336.852l-22.193-16.789l22.193-16.789c18.958-14.342-2.754-42.956-21.669-28.645 l-30.292,22.915l-98.121-74.227V78.304c0-9.918-8.041-17.958-17.958-17.958s-17.958,8.041-17.958,17.958v145.015l-98.121,74.227 l-30.291-22.915c-18.92-14.314-40.618,14.309-21.669,28.645l22.193,16.789L87.96,336.853c-18.959,14.343,2.752,42.954,21.669,28.645 L256,254.772l146.371,110.726C421.341,379.848,442.903,351.123,424.039,336.852z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFBE00"
    },
    d: "M424.039,336.852l-22.193-16.789l22.193-16.789c18.958-14.342-2.754-42.956-21.669-28.645 l-30.292,22.915l-98.121-74.227V78.304c0-9.918-8.041-17.958-17.958-17.958V254.77L402.37,365.497 C421.341,379.848,442.903,351.123,424.039,336.852z"
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLungs);
export default __webpack_public_path__ + "static/media/lungs.0f86edd2e7fc5c19dfa04f3f23cc32a1.svg";
export { ForwardRef as ReactComponent };